import { COMPANY } from "@/data/products";

// Build a WhatsApp deep link with a preformatted message.
export const waLink = (message) => {
    const encoded = encodeURIComponent(message);
    return `https://wa.me/${COMPANY.whatsapp}?text=${encoded}`;
};

export const waProduct = (productName) =>
    waLink(
        `Hello Mist Paints, I'm interested in ${productName}. Could you please share pricing, pack sizes and availability?`,
    );

export const waColor = (color, collectionTitle) =>
    waLink(
        `Hello Mist Paints, I'd like to order shade "${color.name}" (${color.code}) from the ${collectionTitle} range. Please share availability and price.`,
    );

export const waGeneral = () =>
    waLink(
        `Hello Mist Paints, I'd like to enquire about your paint range. Could you share the full catalogue and nearest dealer?`,
    );
